const ADD_FAQ = {
  ADD_PAGE_HEADER_TITLE: 'Add FAQ category',
  ADD_PAGE_HEADER_DESC:
    'In this section, you can insert questions that are frequently asked and you know that they are asked a lot, so that you have a complete FAQ section. With this feature, you can guide your users faster and provide them with answers to their questions even before they ask anything.',
  ADD_FAQ_TITLE_INPUT_PLACEHOLDER: 'Category title',
  ADD_FAQ_DESC_INPUT_PLACEHOLDER: 'Description',
  ADD_PAGE_SUBMIT_BTN_EDIT_LABEL: 'Edit',
  ADD_PAGE_SUBMIT_BTN_ADD_LABEL: 'Add',
  ADD_PAGE_NO_QUESTION_MSG: 'No question has been added',
  ADD_FIELD_MAX_CHAR_EXCEED_ERROR: 'Characters limit exceeded',
  ADD_FAQ_ACTIVE_SWITCH_LABEL: 'Status',
  ADD_QUESTIONS_LABEL: 'Questions',
  ADD_QUESTION_ADD_BTN_LABEL: 'Add',
  ADD_QUESTION_EDIT_BTN_LABEL: 'Edit',
  ADD_QUESTION_TITLE_PLACEHOLDER: 'Question Title',
  ADD_QUESTION_DESC_PLACEHOLDER: 'Description',
  ADD_DELETE_QUESTION_MODAL_MSG:
    'Are you sure you want to delete this question?',
  ADD_PAGE_DELTE_QUESTION_MODAL_BTN: 'Submit',
  ADD_PAGE_DELTE_QUESTION_DESC_TTILE: 'Content',
  ERROR_MESSAGE: 'Filling in all fields is mandatory!',
  TITLE_ERROR_MESSAGE: 'Writing category title is mandatory!',
  DESC_ERROR_MESSAGE: 'Writing descriptions is mandatory!',
  BACK: "Back"
};

export default ADD_FAQ;
